var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Teaser/PublishingInfoText.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var PublishingInfoText = function (_React$Component) {
  (0, _inherits2.default)(PublishingInfoText, _React$Component);

  var _super = _createSuper(PublishingInfoText);

  function PublishingInfoText() {
    (0, _classCallCheck2.default)(this, PublishingInfoText);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PublishingInfoText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          publishingDate = _this$props.publishingDate,
          source = _this$props.source,
          timestamp = _this$props.timestamp,
          textColor = _this$props.textColor;
      var currentDate = timestamp || (0, _moment.default)();
      var published = (0, _moment.default)(publishingDate);
      var timeDiffMin = Math.abs(currentDate.diff(published, 'm'));
      var yesterday = (0, _moment.default)(currentDate).subtract(1, 'days').format('L');
      var publishingDay = (0, _moment.default)(published).format('L');

      if (timeDiffMin <= 59) {
        return _react.default.createElement(_Basic.Text, {
          size: "small",
          m: 2,
          color: textColor || 'font.main',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 27,
            columnNumber: 17
          }
        }, (0, _i18n.default)('teaser_date_prefix') + " " + timeDiffMin + " " + (0, _i18n.default)('minute_short') + " | " + (0, _i18n.default)('source_prefix') + " " + source);
      } else if (timeDiffMin >= 60 && publishingDay === yesterday) {
        return _react.default.createElement(_Basic.Text, {
          size: "small",
          m: 2,
          color: textColor || 'font.main',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 17
          }
        }, (0, _i18n.default)('last_day') + " | " + (0, _i18n.default)('source_prefix') + " " + source);
      }

      return _react.default.createElement(_Basic.Text, {
        size: "small",
        m: 2,
        color: textColor || 'font.main',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 13
        }
      }, publishingDay + " | " + (0, _i18n.default)('source_prefix') + " " + source);
    }
  }]);
  return PublishingInfoText;
}(_react.default.Component);

PublishingInfoText.propTypes = {
  publishingDate: _propTypes.default.string.isRequired,
  source: _propTypes.default.string.isRequired,
  timestamp: _propTypes.default.string,
  textColor: _propTypes.default.string
};
var _default = PublishingInfoText;
exports.default = _default;